import { Flex } from 'foundations-components/components/Flex';
import Visualization from 'reporting-visualizations/Visualization';
import { useSampleDatawellVisualizations } from '../hooks/useSampleVisualizations';
import SampleDataBadge from './SampleDataBadge';
import ZeroStateAlert from './ZeroStateAlert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SampleDatawellVisualization = ({
  report,
  preview
}) => {
  const templateKey = report.get('templateKey');
  const sampleVisualization = useSampleDatawellVisualizations(templateKey);
  return /*#__PURE__*/_jsxs(Flex, {
    children: [/*#__PURE__*/_jsx(SampleDataBadge, {
      preview: preview
    }), /*#__PURE__*/_jsx(Visualization, {
      visualization: sampleVisualization,
      color: "text-core-disabled",
      marginBlockEnd: "1200"
    }), /*#__PURE__*/_jsx(ZeroStateAlert, {
      configReport: report
    })]
  });
};
export default SampleDatawellVisualization;